/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Input, Button, Table, Row, message, Tooltip } from "antd";
import { useNavigate } from "react-router";
import { capitaliseWithHyphen, serialNum } from "../../../utils";
import { camelCase } from "../../../utils";
import search_icon from "../../../assests/images/search-icon.svg";
import { ReactComponent as Copy_Icon } from "../../../assests/images/SVG/copy-icon.svg";
import urls from "../../../api/urls";
import API from "../../../api";
import { APIs, getPremiseId } from "../../../utils/worker";
import { ReactComponent as Scan_check } from "../../../assests/images/SVG/check.svg";

// import ConfirmationModal from "../InScan/confirmationModal";

const { GET_ALL_CP_FROM_HUB } = urls;
let premiseId = getPremiseId();

const NewConsolidatedManifest = () => {
  const [manifestedCp, SetManifestedCp] = useState([]);
  const navigate = useNavigate();
  const [scannedAwbs, setScannedAwbs] = useState([]);

  const [loading, setLoading] = useState(false);
  const [visible, setvisible] = useState(false);
  const [unScannedAwb, setUnscannedAwb] = useState(false);
  const [totalScanned, setTotalScanned] = useState({
    tableTotal: 0,
    scannedCount: 0,
  });
  const [showtoolTip, setShowtoolTip] = useState(false);

  let mock = [
    {
      manifestId: 12323313132,
      status: "OUT-SCANNED",
      premiseId: 489,
      premiseName: "DELHI-GANDHI NAGAR-LAXMI CINEMA",
      createDate: "12-2-110",
      travelBy: "surface",
      awbNumber: 111111111111, //shipemnt
      manifestStatus: "INSCANNED",
      service: "standard",
    },
    {
      manifestId: 4584689698648964,
      status: "INSCANNED",
      premiseId: 489,
      premiseName: "DELHI-GANDHI NAGAR-LAXMI CINEMA",
      createDate: "12-2-110",
      travelBy: "surface",
      awbNumber: 22222222222, //child
      manifestStatus: "INSCANNED",
      service: "standard",
    },
    {
      manifestId: 55467546754546,
      status: "OUT-SCANNED",
      premiseId: 489,
      premiseName: "DELHI-GANDHI NAGAR-LAXMI CINEMA",
      createDate: "12-2-110",
      travelBy: "surface",
      awbNumber: 55555555555555, //packet
      manifestStatus: "OUTSCANNED",
      service: "standard",
    },
    {
      manifestId: 54545454545,
      status: "OUT-SCANNED",
      premiseId: 489,
      premiseName: "DELHI-GANDHI NAGAR-LAXMI CINEMA",
      createDate: "12-2-110",
      travelBy: "surface",
      awbNumber: 666666666666666, //packet
      manifestStatus: "OUTSCANNED",
      service: "standard",
    },
    {
      manifestId: 56676776677676,
      status: "OUT-SCANNED",
      premiseId: 489,
      premiseName: "DELHI-GANDHI NAGAR-LAXMI CINEMA",
      createDate: "12-2-110",
      travelBy: "surface",
      awbNumber: 7777777777777, //packet
      manifestStatus: "OUTSCANNED",
      service: "standard",
    },
  ];
  let found = false;

  useEffect(() => {
    getManifest();
  }, []);

  useEffect(() => {
    let totalScanned = manifestedCp.filter((val) => {
      return (
        // val.status === "SORTED" ||
        // val.status === "HUB-IN-SCANNED" ||
        // val.status === "INSCANNED" ||
        // val.status === "BAGGED" ||
        // val.status === "RECEIVED_IN_PACKET" ||
        // val.status === "OUTSCANNED_IN_PACKET" ||
        // val.status === "MANIFESTED_FOR_CP" ||
        // val.status === "OUT_FOR_DELIVERY" ||
        // val.status === "PACKETED" ||
        // val.status === "DRS_GENERATED" ||
        // val.status === "OUTSCANNED_TO_CP"
        val.status !== "MANIFESTED"
      );
    });
    setTotalScanned({
      tableTotal: manifestedCp.length,
      scannedCount: totalScanned?.length,
    });
  }, [manifestedCp]);

  const getManifest = async () => {
    setLoading(true);
    let response = await API.Api(
      GET_ALL_CP_FROM_HUB + premiseId?.split("Bearer ")[1]
    ).getWithHeader();
    if (response.status) {
      setLoading(false);
      SetManifestedCp(
        response?.response?.data.sort(function (a, b) {
          return a.status !== "MANIFESTED"
            ? 1
            : b.status != "MANIFESTED"
            ? -1
            : 0;
        })
      );
    } else {
      setLoading(false);
      message.error(response.response.data.message || "Network error");
    }
    // SetManifestedCp(mock);
  };

  const handleScanByDebounce = async (id) => {
    setLoading(true);
    let barcodes = [id];
    let response = await API.Api(`${APIs.baseURL}/in-scan/v1`).postIdHeader({
      barcodes,
    });
    if (response.status) {
      setLoading(false);
      setScannedAwbs([]);
      message.success(
        response?.response?.data?.message || id + " scanned successfully"
      );
      getManifest();
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  let filterData = () => {
    const unique = [
      ...new Map(
        manifestedCp?.map((item) => [item["manifestId"], item])
      ).values(),
    ];

    let data = unique?.map((val) => {
      return { text: val.manifestId, value: val.manifestId };
    });

    return data;
  };

  function copyText(text) {
    setShowtoolTip(!showtoolTip);
    navigator.clipboard.writeText(text);
  }

  const handleSubmit = async () => {
    if (scannedAwbs.length == 0) {
      return navigate("/dashboard");
    }

    let barcodes = [...new Set(scannedAwbs)];
    let response = await API.Api(`${APIs.baseURL}/in-scan/v1`).postIdHeader({
      barcodes,
    });
    if (response.status) {
      setLoading(false);
      navigate("/dashboard");
      // handleStatus("/sort-shipment");
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network error");
    }
  };

  //--Barcode Scanner--//
  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleScanByDebounce(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const columns = [
    {
      title: "Sl No",
      align: "center",
      // width: 10,
      render: (a, b, idx) => serialNum(10, 1, idx),
    },
    {
      title: "Awb No/Packet Id",
      dataIndex: "awbNumber",
      width: 200,
      key: "awbNumber",
      render: (text, val) => {
        return (
          <div className="d-flex">
            <div style={{ width: "170px" }}>
              <span style={{ marginRight: "15px" }}>{text}</span>
            </div>

            <Tooltip title={showtoolTip ? "Copied" : "Copy"}>
              <span
                style={{ marginRight: "10px" }}
                className="pointer"
                onClick={() => copyText(text)}
              >
                <Copy_Icon />
              </span>
            </Tooltip>

            {
              // val.status === "HUB-IN-SCANNED" ||
              // val.status === "SORTED" ||
              // val.status === "IN_SCANNED" ||
              // val.status === "INSCANNED" ||
              // val.status === "BAGGED" ||
              // val.status === "RECEIVED_IN_PACKET" ||
              // val.status === "MANIFESTED_FOR_CP" ||
              // val.status === "OUT_FOR_DELIVERY" ||
              // val.status === "OUTSCANNED_IN_PACKET" ||
              // val.status === "OUTSCANNED_TO_CP" ||
              // val.status === "DRS_GENERATED" ||
              // val.status === "PACKETED"

              val.status !== "MANIFESTED" && <Scan_check />
            }
          </div>
        );
      },
    },

    {
      title: "Manifest ID",
      dataIndex: "manifestId",
      filters: filterData(),
      width: 150,

      onFilter: (value, record) => record.manifestId === value,
      key: "manifestId",
    },

    {
      title: "Date",
      dataIndex: "createDate",
      key: "createDate",
      render: (text) => <div style={{ whiteSpace: "nowrap" }}>{text}</div>,
    },
    {
      title: "CP Name",
      dataIndex: "premiseName",
      key: "premiseName",
      render: (text) => <div>{capitaliseWithHyphen(text)}</div>,
    },
    {
      title: "Mode of Manifest",
      dataIndex: "travelBy",
      key: "travelBy",
      render: (text) => <div>{camelCase(text)}</div>,
    },

    {
      title: "Service Type",
      dataIndex: "service",
      key: "service",
      render: (text) => <div>{camelCase(text)}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  function closeSuccessModal(params) {
    setvisible(false);
  }

  function handleSuccessOk(params) {
    setvisible(false);
    handleSubmit();
  }

  function openModal() {
    // const notScanned =
    //   manifestedCp &&
    //   manifestedCp?.filter((manifest) => manifest?.status !== "INSCANNED");
    // if (notScanned?.length == 0) {
    //   handleSubmit();
    // } else {
    //   setUnscannedAwb(notScanned);
    //   setvisible(true);
    // }
    navigate("/middle-mile");
  }

  const onChange = (pagination, filters, sorter, extra) => {
    let totalScann = extra.currentDataSource.filter((val) => {
      return (
        // val.status === "SORTED" ||
        // val.status === "HUB-IN-SCANNED" ||
        // val.status === "INSCANNED" ||
        // val.status === "BAGGED" ||
        // val.status === "RECEIVED_IN_PACKET" ||
        // val.status === "OUTSCANNED_IN_PACKET" ||
        // val.status === "PACKETED" ||
        // val.status === "OUTSCANNED_TO_CP" ||
        // val.status === "MANIFESTED_FOR_CP" ||
        // val.status === "DRS_GENERATED" ||
        // val.status === "OUT_FOR_DELIVERY"
        val.status !== "MANIFESTED"
      );
    });
    return setTotalScanned({
      tableTotal: extra.currentDataSource.length,
      scannedCount: totalScann?.length,
    });
  };

  return (
    <>
      {/* <ConfirmationModal
        visible={visible}
        handleCancel={closeSuccessModal}
        handleOk={handleSuccessOk}
        awbNumbersUnScanned={unScannedAwb || null}
      /> */}
      <div className="consolidated-manifest-cntr">
        <div className="header">
          <div className="right">
            <Input
              placeholder="Scan by AWB No/Packet Id"
              bordered
              style={{ borderRadius: "5px", height: "40px", minWidth: "250px" }}
              suffix={<img src={search_icon} />}
              onChange={(e) => {
                // eslint-disable-next-line no-constant-condition
                if (e.target.value.length > 6) {
                  handleScanByDebounce(parseInt(e.target.value));
                }
              }}
            />
          </div>
          <p>
            Scanned shipments {totalScanned?.scannedCount}/
            {totalScanned?.tableTotal}
          </p>
        </div>
        {/* <Row> */}
        <Table
          columns={columns}
          dataSource={manifestedCp}
          scroll={{ x: 800, y: 1000 }}
          loading={loading}
          pagination={false}
          onChange={onChange}
        />
        {/* </Row> */}
      </div>
      <Row className="flex-end mt-2">
        <Button
          className="save-btn"
          style={{ textAlign: "end" }}
          onClick={openModal}
          // disabled={checkInScanned}
        >
          DONE
        </Button>
      </Row>
    </>
  );
};

export default NewConsolidatedManifest;
